import { useSelector } from "react-redux";
import { Like, Performance, Rewards, Star } from "@assets/Icons";
import styles from "./styles.module.scss";
import { formatDate } from "@utils/formatDate";
import useDiscountCountdown from "@hooks/useDiscountCountdown";
import { useOnboardingTexts } from "src/routes/onboarding/shared/hooks/useOnboardingTexts";
import { WORKFLOW } from "src/appConfig";

export const PersonalPlan = ({ isSomatic }) => {
  const {
    time: { displayMinutes, displaySeconds },
  } = useDiscountCountdown();

  const { getSectionText } = useOnboardingTexts();

  const title = getSectionText("payment").title;
  const isWalky = WORKFLOW === "WALKY";

  const userInfo = useSelector((state) => state.user.userInfo);
  const weightMs = userInfo?.questions.qqGoalWeightKg ? "kg" : "lbs";
  const goalWeight =
    userInfo?.questions.qqGoalWeightKg || userInfo?.questions.qqGoalWeightLbs;
  const weight =
    userInfo?.questions.qqWeightKg || userInfo?.questions.qqWeightLbs;

  const isGainWeight = goalWeight > weight;

  return (
    <div className={styles.personalPlan}>
      <h2>
        Your tailored{" "}
        <span className={isWalky ? "" : styles.defaultBlue}>weight loss</span>{" "}
        plan is ready!{" "}
      </h2>
      <div className={`${styles.card} ${styles.outlined}`}>
        <div className={styles.cardListItemWithIcon}>
          <div
            className={styles.icon}
            style={{ transform: isGainWeight ? "scaleY(-1)" : "scaleY(1)" }}
          >
            <Performance />{" "}
          </div>
          <p>
            <strong>
              {isGainWeight ? "Gain" : "Lose"} {Math.abs(goalWeight - weight)}{" "}
              {weightMs}
            </strong>{" "}
            by{" "}
            {formatDate(
              userInfo?.fitnessProfile.weightGoalCompletionEstimatedDate
            )}
            .
          </p>
        </div>
        <div className={styles.cardListItemWithIcon}>
          <div className={styles.icon}>
            <Rewards />
          </div>
          <p>
            Continue developing healthy habits to keep the weight off after
            reaching your goal
          </p>
        </div>
        <div className={styles.cardListItemWithIcon}>
          <div className={styles.icon}>
            <Like />
          </div>
          <p>
            {isSomatic
              ? "Release yourself from the hold of stress."
              : "Custom program to follow every day."}
          </p>
        </div>
      </div>
      <div className={`${styles.card} ${styles.filled}`}>
        <h3>Your personalized plan is reserved!</h3>
        <h4>
          We've reserved your{" "}
          <strong>
            {isSomatic
              ? "Somatic"
              : isGainWeight
              ? "Gain weight"
              : "Loss weight"}{" "}
          </strong>
          plan for 10 minutes. Don’t miss out!
        </h4>
        <h4>
          <strong>
            EXPIRES IN:{" "}
            <span className={styles.countdown}>
              {displayMinutes}:{displaySeconds}
            </span>
          </strong>
        </h4>
      </div>
    </div>
  );
};
